import { Text } from '@querodelivery/uni-react';
import { Form } from '@radix-ui/react-form';
import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDebounceValue } from 'usehooks-ts';
import styles from './deliverymen-by-mission-table.module.scss';
import { TextInput } from '@/_components/text-input/text-input';
import { useGetMissionRanking } from '../../api/get-mission-ranking';
import { DeliverymenRankingTableContent } from './deliverymen-ranking-table-content';

const SEARCH_DEBOUNCE_MS = 500;
const RANKING_LIMIT = 10;

type DeliverymanByMissionTableProps = {
  missionId: string;
};

export const DeliverymanByMissionTable = ({
  missionId,
}: DeliverymanByMissionTableProps) => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [debouncedSearch] = useDebounceValue(search, SEARCH_DEBOUNCE_MS);

  const {
    data: ranking,
    isLoading,
    isError,
    isFetching,
  } = useGetMissionRanking({
    missionId,
    page,
    limit: RANKING_LIMIT,
    deliverymanName: debouncedSearch.trim() || undefined,
  });

  useEffect(() => {
    setPage(1);
  }, [debouncedSearch]);

  const handleNavigateToDeliverymanDetails = (deliverymanId: string) => {
    navigate(`/entregadores/${deliverymanId}`);
  };

  const deliverymen = ranking?.data ?? [];
  const totalCount = ranking?.totalCount ?? 0;
  const showPagination = totalCount > RANKING_LIMIT;
  const isInitialLoading = isLoading && !ranking;

  return (
    <Form className={styles.container}>
      <div className={styles.headerContainer}>
        <Text fontSize="sm" fontWeight="bold" lineHeight="lg" tone="secondary">
          Ranking de entregadores
        </Text>
        <TextInput
          name="searchDeliveryman"
          className={styles.textInputContainer}
          icon={faMagnifyingGlass}
          placeholder="Buscar entregador"
          value={search}
          onChange={event => setSearch(event.target.value)}
        />
      </div>
      <DeliverymenRankingTableContent
        deliverymen={deliverymen}
        isInitialLoading={isInitialLoading}
        isError={isError}
        isFetching={isFetching}
        page={page}
        searchTerm={debouncedSearch}
        showPagination={showPagination}
        totalCount={totalCount}
        onPageChange={setPage}
        onNavigateToDeliverymanDetails={handleNavigateToDeliverymanDetails}
      />
    </Form>
  );
};
